import React from "react";
import { Pencil, Trash2, RotateCcw } from "lucide-react";
import SearchableSelect from "./SearchableSelect";

export default function UserDataTable({
  data,
  loading,
  error,
  currentPage = 1,
  itemsPerPage = 10,
  totalEntries = 0,
  onEdit,
  onDelete,
  onResetPassword,
}) {
  return (
    <div className="bg-white rounded-lg border border-gray-200">
      {loading && (
        <div className="px-6 py-12 flex items-center justify-center text-gray-500">
          Loading data...
        </div>
      )}

      {!loading && !error && (
        <>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase w-32">
                    Aksi
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase w-24">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">
                    Nama Lengkap
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">
                    Jabatan
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">
                    Role
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">
                    Alamat Email
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">
                    No Handphone
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {data.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50 transition">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-1.5">
                        <button
                          onClick={() => onEdit(item)}
                          className="w-8 h-8 bg-slate-700 text-white rounded-lg hover:bg-slate-800 flex items-center justify-center transition-colors"
                          title="Edit">
                          <Pencil className="w-3.5 h-3.5" />
                        </button>
                        <button
                          onClick={() => onDelete(item)}
                          className="w-8 h-8 bg-rose-500 text-white rounded-lg hover:bg-rose-600 flex items-center justify-center transition-colors"
                          title="Hapus">
                          <Trash2 className="w-3.5 h-3.5" />
                        </button>
                        <button
                          onClick={() => onResetPassword(item)}
                          className="w-8 h-8 bg-amber-500 text-white rounded-lg hover:bg-amber-600 flex items-center justify-center transition-colors"
                          title="Reset Password">
                          <RotateCcw className="w-3.5 h-3.5" />
                        </button>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-block px-3 py-1 rounded border text-xs font-medium ${
                          item.status === "Aktif"
                            ? "bg-green-50 text-green-700 border-green-200"
                            : "bg-red-50 text-red-700 border-red-200"
                        }`}>
                        {item.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      {item.name}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {item.position}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {item.role}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {item.email}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {item.phone}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
            <span className="text-sm text-gray-600">
              Showing 1 to {data.length} of {totalEntries || 999} entries
            </span>
            <SearchableSelect
              options={[
                { value: 10, label: "10" },
                { value: 25, label: "25" },
                { value: 50, label: "50" },
                { value: 100, label: "100" },
              ]}
              value={10}
              onChange={() => {}}
              placeholder="Items per page"
              displayKey="label"
              valueKey="value"
              className="w-20"
              searchable={false}
              size="sm"
            />
          </div>
        </>
      )}
    </div>
  );
}
